<!-- Main Container -->
<div class="page-inner-body portlet light">
  <div class="portlet-body">

    <!-- Toolbar Section -->
    <div class="table-toolbar mb-4">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="bg-white">
            <!-- Left Side: Title and Description -->
            <div class="p-toolbar-group-start">
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="d-flex align-items-center fs-5 fw-bold">
                  {{ 'shopifyAccount.connectAccountToShopify' | transloco }}
                </div>
                <div class="text-muted">
                  {{ 'shopifyAccount.manageConnections' | transloco }}
                </div>
              </div>
            </div>

            <!-- Right Side: Connect Button -->
            <div class="p-toolbar-group-end">
              <div class="text-end">
                <button pButton type="button" class="p-button p-button-outlined p-button-sm fw-bold shadow-sm"
                  (click)="onShowShopifyConnectionDailog()">
                  {{ 'shopifyAccount.connectShopifyAccount' | transloco }}
                  <i class="pi pi-plus ms-2"></i>
                </button>
              </div>
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>

    <!-- Shopify Accounts Display Section -->
    <div class="mt-4 border-bottom pb-4">
      <div class="row">
        <!-- Account Card - Repeats for each connected Shopify account -->
        @for (shop of shopifyAccounts; track shop) {
          <div class="col-md-12 col-lg-4 mb-2">
            <div class="card border-0 shadow rounded-4 h-100">
              <div class="card-body p-4 d-flex flex-column justify-content-between position-relative">
                <!-- Account Menu Button (3-dot menu) -->
                <div class="position-absolute end-0 top-0 p-2">
                  <button class="btn btn-light btn-sm rounded-circle" (click)="ShopifyMenuPanel.toggle($event)">
                    •••
                  </button>
                </div>
                <!-- Store Information Section -->
                <div class="d-flex align-items-center mb-2">
                  <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="me-2"
                    style="height: 30px; width: 30px;" />
                    @if (shop.StoreName) {
                      <div>
                        {{ shop.StoreName }}
                      </div>
                    }
                  </div>
                  <!-- Store Details -->
                  @if (shop.StoreDomain) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.domain' | transloco }}</div>
                      <span class="ms-2">{{ shop.StoreDomain }}</span>
                    </div>
                  }
                  @if (shop.StoreEmail) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.email' | transloco }}</div>
                      <span class="ms-2">{{ shop.StoreEmail }}</span>
                    </div>
                  }
                  @if (shop.StoreCountryName) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.country' | transloco }}</div>
                      <div class="ms-2">{{ shop.StoreCountryName }}</div>
                    </div>
                  }
                  @if (shop.StoreCurrency) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.currency' | transloco }}</div>
                      <div class="ms-2">{{ shop.StoreCurrency }}</div>
                    </div>
                  }
                  @if (shop.StoreUrl) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.storeUrl' | transloco }}</div>
                      <a [href]="shop.StoreUrl" target="_blank" class="text-primary text-decoration-none small ms-1">
                        {{ shop.StoreUrl }}
                      </a>
                    </div>
                  }
                  @if (shop.AdminPanelUrl) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.adminPanel' | transloco }}</div>
                      <a [href]="shop.AdminPanelUrl" target="_blank" class="text-primary text-decoration-none small ms-1">
                        {{ shop.AdminPanelUrl }}
                      </a>
                    </div>
                  }
                  @if (shop.CreatedDate) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'shopifyAccount.connected' | transloco }}</div>
                      <div class="ms-2">{{ shop.CreatedDate | date: 'dd/MM/yyyy' }}</div>
                    </div>
                  }
                  <!-- Account Management Overlay Panel -->
                  <p-overlayPanel #ShopifyMenuPanel>
                    <div class="px-4 py-2 small text-start">
                      <div class="mb-2 text-muted">{{ 'shopifyAccount.manageThisAccount' | transloco }}</div>
                      <button pButton type="button"
                        class="p-button p-button-danger p-button-sm w-100 justify-content-center text-center"
                        (click)="onDisconnectShopifyAccount(shop); ShopifyMenuPanel.hide()">
                        {{ 'shopifyAccount.disconnectAccount' | transloco }}
                      </button>
                      <!-- Disconnection Warning Information -->
                      <div class="text-muted mt-3 small">
                        {{ 'shopifyAccount.disconnectWarningIntro' | transloco }}
                        <ul class="mt-1 ps-3">
                          <li>{{ 'shopifyAccount.disconnectWarningStopSync' | transloco }}</li>
                          <li>{{ 'shopifyAccount.disconnectWarningPreventManaging' | transloco }}</li>
                          <li>{{ 'shopifyAccount.disconnectWarningRemoveData' | transloco }}</li>
                          <li>{{ 'shopifyAccount.disconnectWarningReconnect' | transloco }}</li>
                        </ul>
                        {{ 'shopifyAccount.disconnectWarningConfirm' | transloco }}
                      </div>
                    </div>
                  </p-overlayPanel>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Empty State Message -->
        @if (!shopifyAccounts || shopifyAccounts.length === 0) {
          <div class="text-center mt-4">
            <div class="text-muted">{{ 'shopifyAccount.noAccountDetailsFound' | transloco }}</div>
          </div>
        }
      </div>

      <!-- Product Sync Component -->
      @if (shopifyAccounts && shopifyAccounts.length > 0) {
        <div>
          <app-sync-products [SyncProducts]="Products" [shopifySyncProducts]="shopifySyncProducts">
          </app-sync-products>
        </div>
      }
    </div>
  </div>

  <!-- Shopify Connection Dialog -->
  @if (isShopifyConnectionDailogVisible) {
    <shopify-and-woocommerce-dailog [platform]="'shopify'"
      [isAddPlatformAccountDailogVisible]="isShopifyConnectionDailogVisible"
      (onClosePlatformCredentialDailog)="onCloseShopifyConnectionDailog($event)">
    </shopify-and-woocommerce-dailog>
  }

  <!-- Success Dialog -->
  <p-dialog [header]="'shopifyAccount.connectionSuccess' | transloco" [(visible)]="isShopifyCheckoutSuccessDialogVisible" [modal]="true"
    (onHide)="onCloseShopifyCheckoutDialog()" [style]="{ 'width': '430px'}">
    <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
      <img src="assets/images/tik-image.jpg" [alt]="'shopifyAccount.success' | transloco" class="img-fluid rounded-circle" style="width: 100px;">
      <div class="h5 mt-4 text-secondary">
        {{ 'shopifyAccount.accountConnectedSuccessfully' | transloco }}
      </div>
      <div class="text-secondary">
        {{ 'shopifyAccount.storeLinkedDescription' | transloco }}
      </div>
    </div>
  </p-dialog>